import React from 'react';
import { useSelector } from 'react-redux';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import TransitionPage from 'js/containers/transition/Transition.page';
import IconShapes from 'js/components/icon/Icon.shapes';
import CollectionCarousel from 'js/components/collections/Collections.carousel';
import HeaderInfo from 'js/components/header/Header.info';
import ActivityCardCarousel from 'js/components/activity-card/ActivityCard.carousel';

// import selectors
import { getUserFavoritedCards } from 'js/store/cards/Cards.selectors';
import { setScreenName } from '../utils/tracking';
import { getTranslationById, getSiteMetaData } from 'js/store/app/App.selectors';

const InfoText = ({ siteText }) => {
  return (
    <>
      <p>{siteText.libraryInfoText1}</p>
      <div className="info-text__component" style={{ border: 'solid #D35063 2px', borderRadius: '20px', padding: 25 }}>
        <div style={{ color: '#D35063', fontWeight: 'bold', fontSize: 24 }}>{siteText.libraryInfoText2Title}</div>
        <p style={{ fontSize: 20 }}>{siteText.libraryInfoText2}</p>
      </div>
    </>
  );
};

const PageLibrary = ({ path }) => {
  const favoritedCards = useSelector((state) => getUserFavoritedCards(state));
  const siteMetaData = useSelector((state) => getSiteMetaData(state, path));

  const siteText = {
    libraryTitle: useSelector((state) => getTranslationById(state, 'library_page_title', 'Your Library')),
    libraryInfoText1: useSelector((state) =>
      getTranslationById(
        state,
        'library_page_info_text_1',
        'Your Library contains all the cards, curated collections and galleries you have saved.'
      )
    ),
    libraryInfoText2Title: useSelector((state) =>
      getTranslationById(state, 'library_page_info_text_2_title', 'Good to know')
    ),
    libraryInfoText2: useSelector((state) =>
      getTranslationById(
        state,
        'library_page_info_text_2',
        'Cards are saved locally to your device. This means, if you remove the web app or clear your web browser cache, you will lose these saved items.'
      )
    ),
    libraryCategoryYourGalleries: useSelector((state) =>
      getTranslationById(state, 'library_page_category_your_galleries', 'Your Galleries')
    ),
    libraryCategoryCuratedCollections: useSelector((state) =>
      getTranslationById(state, 'library_page_category_curated_collections', 'Curated Collections')
    ),
    libraryCategoryActivityCards: useSelector((state) =>
      getTranslationById(state, 'library_page_category_activity_cards', 'Activity Cards')
    ),
  };

  React.useEffect(() => {
    setScreenName('Library');
    setBodyBackgroudColor('#F7EBB1');
  }, []);

  return (
    <TransitionPage>
      <GenericMetadata
        title={siteMetaData.title}
        description={siteMetaData.description}
        keywords={siteMetaData.keywords}
      />
      <SectionPageWrapper className="page--library" bgColor="#F7EBB1">
        <HeaderInfo title={siteText.libraryTitle} infoText={<InfoText siteText={siteText} />} />
        <IconShapes className="icon-shapes" />
        <CollectionCarousel title={siteText.libraryCategoryYourGalleries} />
        <CollectionCarousel title={siteText.libraryCategoryCuratedCollections} type="curated" filter="user-favorites" />
        <ActivityCardCarousel title={siteText.libraryCategoryActivityCards} cards={favoritedCards} url="/favorites" />
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageLibrary;
